import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import SessionView from "@/pages/SessionView";
import Reflection from "@/pages/Reflection";
import History from "@/pages/History";
import Stats from "@/pages/Stats";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import RequireAuth from "@/components/RequireAuth";
import { AuthProvider } from "@/contexts/AuthContext";

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth callback synchronously so it processes before any /auth/me check
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/home" element={<RequireAuth requireProfile><Dashboard /></RequireAuth>} />
      <Route path="/session/:id" element={<RequireAuth requireProfile><SessionView /></RequireAuth>} />
      <Route path="/reflection/:id" element={<RequireAuth requireProfile><Reflection /></RequireAuth>} />
      <Route path="/history" element={<RequireAuth requireProfile><History /></RequireAuth>} />
      <Route path="/stats" element={<RequireAuth requireProfile><Stats /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth requireProfile><Settings /></RequireAuth>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
